import { render, staticRenderFns } from "./ManageSetting.vue?vue&type=template&id=360b3214&scoped=true"
import script from "./ManageSetting.vue?vue&type=script&lang=js"
export * from "./ManageSetting.vue?vue&type=script&lang=js"
import style0 from "./ManageSetting.vue?vue&type=style&index=0&id=360b3214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360b3214",
  null
  
)

export default component.exports